// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2HK09","amount":"Amount_amount__1lXiv","tip":"Amount_tip__1RKXk","tipHeader":"Amount_tipHeader__3wHV3","tipsWrap":"Amount_tipsWrap__3SPp5"};